module.exports = __webpack_public_path__ + "static/media/img_25.419bc8eb.JPG";